import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const res = await fetch(
                "https://sauvegarde.amservices.eu/api/auth/login.php",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ username, password }),
                }
            );

            const data = await res.json();

            // On vérifie si le token existe dans la réponse (car res.ok sera false si 401)
            if (data.token) {
                // ON UTILISE TES CLÉS EXACTES :
                localStorage.setItem("token", data.token);
                localStorage.setItem("isAdmin", "true"); // On le met en string comme souvent dans le localStorage

                navigate("/simulation");
            } else {
                // On affiche le message d'erreur brut du PHP pour savoir si c'est le mdp ou l'user
                setError(data.error || "Identifiants incorrects");
            }
        } catch (err) {
            setError("Erreur de connexion serveur");
        }
    };

    return (
        <div className="login-container"> {/* Changé ici */}
            <div className="login-card"> {/* Simplifié ici */}
                <h1>Connexion</h1>

                <form className="login-form" onSubmit={handleSubmit}> {/* Changé ici */}
                    <div className="input-group">
                        <label className="stat-label">Utilisateur</label>
                        <input
                            type="text"
                            placeholder="Nom d’utilisateur"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <label className="stat-label">Mot de passe</label>
                        <input
                            type="password"
                            placeholder="Mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && (
                        <div className="login-error">
                            ⚠️ {error}
                        </div>
                    )}

                    <button type="submit">
                        Se connecter
                    </button>
                </form>
            </div>
        </div>
    );
}